import '/lib/uf-functions.js';
import DragEvents from '/lib/drag_events.js'
const imageComparisonContainer = document.querySelectorAll('.pp-image-comparison__container');

if (imageComparisonContainer) {
    [...imageComparisonContainer].map( clipper => {
        const imageComparisonClippingHandler = clipper.querySelector('.pp-image-comparison__clipping-handler')
        const clippedImg = clipper.querySelector('.pp-image-comparison__images > figure')

        if ( !clippedImg ) return

        new DragEvents({
            element: imageComparisonClippingHandler,
            click: true,
            dragging: true,
            vectors: [ 'x' ],
            affectParent: true
        }).render( attributes => {
            const { props, parent, state, updateState } = attributes
            const { element } = props
            const { cursorMovePosition, elementSize, parentSize, event } = state

            if ( event === 'touchmove' || event === 'touchend' || event === 'click' ) {
                updateState({ elementPosition: { x: cursorMovePosition['x'] - parent.offset().left - elementSize['x'] / 2 } })

                const leftMargin = -25;
                const rightMargin = parentSize['x'] - elementSize['x'] + 25

                if ( attributes.state.elementPosition['x'] <= leftMargin ) updateState({ elementPosition: { x: leftMargin } })
                if ( attributes.state.elementPosition['x'] >= rightMargin ) updateState({ elementPosition: { x: rightMargin } })
                
                element.setProperty('transform', `translate3d(${attributes.state.elementPosition['x'] || 0}px, ${attributes.state.elementPosition['y'] || 0}px, ${attributes.state.elementPosition['z'] || 0}px)`)
                clippedImg.setProperty('clip', `rect(0px, ${attributes.state.elementPosition['x'] + elementSize['x'] / 2 || 0}px, auto, 0px)`)
            }

            if ( event === 'init' ) {
                clipper.classList.add('pp-image-comparison__container--active')

                element.setProperty('transform', `translate3d(${parentSize['x'] / 2 - elementSize['x'] / 2 || 0}px, ${attributes.state.elementPosition['y'] || 0}px, ${attributes.state.elementPosition['z'] || 0}px)`)
                clippedImg.setProperty('clip', `rect(0px, ${parentSize['x'] / 2 || 0}px, auto, 0px)`)
            }
        })
    })
}